import FullLayout from 'layout/FullLayout';
import LiteYouTubeAutoplay from 'components/LiteYouTubeAutoplay';
import HeroSection from './HeroSection';
import KiNstallationSection from './KinInstallation';
import KinteractiveSection from './KinteractiveSection';
import KinArtGallery from './KinArtGallery';
import KinCommunity from './KinCommunity';
import KinLearnspace from './KinLearnspace';
import KinPartnership from './KinPartnership';

const About = () => {
  return (
    <FullLayout>
      <HeroSection />

      <section>
        <div className="mx-auto max-w-7xl px-6 py-16 lg:py-24">
          <div className="max-w-2xl">
            <h2 className="text-2xl font-bold tracking-tight text-pretty text-primary-main">
              KiN Space
            </h2>
            <p className="mt-4 text-base text-pretty text-kin-text">
              KiN Space is in SCBD Park, Jakarta. This family space offers a unique blend of
              exhibition, play, learning, gallery, retail, and a cozy cafe.
            </p>
          </div>

          <div className="mt-6">
            <LiteYouTubeAutoplay videoId="mVlst7jWo0g" className="w-full" />
          </div>
        </div>
      </section>

      {/* <KiNstallationSection
        posterSrc={'kin/assest/image/play-exhibition.webp'}
        gallery={[
          'kin/assest/about/asset_about_10.webp',
          'kin/assest/about/asset_about_13.webp',
          'kin/assest/about/asset_about_12.webp',
        ]}
        artists={[
          {
            name: 'Eko Nugroho',
            role: 'Artist',
            image: 'kin/assest/about/eko-nugroho.webp',
            desc: `He is an internationally recognized contemporary artist based in Yogyakarta, one of Indonesia’s most vital artistic hubs. A graduate of the Indonesian Institute of the Arts Yogyakarta, Eko’s background in street art and community-based work forms the core of his artistic practice.
His multidisciplinary works range from painting, drawing, and embroidery to murals, sculpture, and video, deeply rooted in local traditions and the vibrant realities of urban life. His distinctive visual style—bold, colorful, and infused with the aesthetics of street art, graffiti, and comics—often delivers powerful social and political messages.`,
            image_project: [
              'kin/assest/about/asset_about_4.webp',
              'kin/assest/about/asset_about_10.webp',
              'kin/assest/about/asset_about_5.webp',
            ],
            href: 'https://www.instagram.com/ekonugroho_studio/',
            project: {
              name: 'Save Our Future',
              logo: 'kin/assest/about/title_about_3.webp',
              desc: `Save Our Future’ by Eko Nugroho brings an imaginative landscape where childhood memories, fantasy, and hope converge—inviting both children and adults to reconnect with the wonder within themselves. Through his distinctive artistic language—playful characters, bold visual motifs, and surreal landscapes—Eko builds an imaginative universe that invites exploration, interaction, and quiet contemplation.`,
              url_video: 'https://www.youtube.com/watch?v=qc0IySwSasA',
            },
          },
          {
            name: 'Eldwin Pradipta',
            role: 'Artist',
            image: 'kin/assest/about/eldwin-pradipta.webp',
            desc: `A contemporary artist known for blending art and technology in groundbreaking ways. Starting his journey in new media art at Institut Teknologi Bandung in 2008, he gained recognition with a thesis project that reimagined traditional landscapes through digital projections, exploring environmental themes. His career took off with a debut at ArtJog 2012.

Eldwin’s notable works include a water-screen projection at Jakarta’s Hotel Indonesia Roundabout for Independence Day and his award-winning installation Gold-Shaping The Future at Art Jakarta 2023, earning him the Treasury Art Prize and the title of Prestige Indonesia’s "It Artist" of the Year. With bold ideas and innovative techniques, Eldwin continues to redefine the intersection of art and technology.
`,
            image_project: [
              'kin/assest/about/asset_about_6.webp',
              'kin/assest/about/asset_about_12.webp',
              'kin/assest/about/asset_about_16.webp',
            ],
            href: 'https://www.instagram.com/eldwinpradipta/',
            project: {
              name: 'Pola Pola Bejana `The Vessel Patterns`',
              logo: 'kin/assest/about/title_about_2.webp',
              desc: `The Vessel Patterns brings history, art, and interaction to life, creating an experience that is both meaningful and enjoyable. Inspired by antique vessels from China and the Netherlands—discovered in shipwrecks and ancient sites in East and West Java—this exhibition highlights Nusantara’s significant role in global trade centuries ago.`,
              url_video: 'https://www.youtube.com/watch?v=awG_LQvCUOE',
            },
          },
          {
            name: 'Mulyana (Mang Moel)',
            role: 'Artist',
            image: 'kin/assest/about/mangmole.webp',
            desc: `Inspired by his visit to Alor Island, Moel invites us to admire the Indonesian seas. In a pink room reflecting eastern Indonesia's sands, we find corals, sea plants, and whale sharks. Moel highlights coral's role as a guardian, protecting fish and providing shelter. Fan coral withstands waves, creating calm spaces for marine life. Moel's work urges us to nurture the sea's goodness.`,
            image_project: [
              'kin/assest/about/asset_about_13.webp',
              'kin/assest/about/asset_about_14.webp',
              'kin/assest/about/asset_about_15.webp',
            ],
            href: 'https://www.instagram.com/mangmoel/',
            project: {
              name: 'Imaji Laut Timur Nusantara `Imagery Of Eastern Nusantara Seas`',
              logo: 'kin/assest/about/title_about_1.webp',
              desc: `Inspired by his visit to Alor Island, Moel invites us to admire the Indonesian seas. In a pink room reflecting eastern Indonesia's sands, we find corals, sea plants, and whale sharks. Moel highlights coral's role as a guardian, protecting fish and providing shelter. Fan coral withstands waves, creating calm spaces for marine life. Moel's work urges us to nurture the sea's goodness.`,
              url_video: 'https://www.youtube.com/watch?v=iWff67-0APA',
            },
          },
        ]}
      /> */}

      {/* <KinteractiveSection
        collaborators={[
          { name: 'Gula', role: 'Artist', avatar: 'kin/assest/about/gula.webp' },
          { name: 'Liunic', role: 'Artist', avatar: 'kin/assest/about/liunic.webp' },
          { name: 'Ika Vantiani', role: 'Artist', avatar: 'kin/assest/about/ika.webp' },
          { name: 'Tennessee Caroline', role: 'Artist', avatar: 'kin/assest/about/tennessee.webp' },
          { name: 'Ria Paramita', role: 'Artist', avatar: 'kin/assest/about/ria.webp' },
          { name: 'Aphrodita Wibowo', role: 'Artist', avatar: 'kin/assest/about/aphrodita.webp' },
        ]}
        exhibits={[
          {
            title: 'Sensory Fishing Pool',
            blurb:
              'A shallow pool filled with water beads and floating sea-animal toys. Kids scoop, ‘fish’, and sort—tactile play that builds fine-motor skills and co-play.',
            image: 'kin/assest/about/interactive1.webp',
            tags: ['Sensory', 'Fine Motor', 'Co-play'],
          },
          {
            title: 'Mask Painting Studio',
            blurb:
              'Children paint blank masks with brushes and bright colours—exploring patterns, textures, and self-expression through hands-on making.',
            image: 'kin/assest/about/interactive2.webp',
            tags: ['Creativity', 'Art', 'Hands-on'],
          },
        ]}
        onPrimaryCta={() => console.log('View schedule')}
        onSecondaryCta={() => console.log('Plan visit')}
      /> */}

      <KinArtGallery />
      <KinLearnspace />
      {/* <KinCommunity /> */}
      <KinPartnership />
    </FullLayout>
  );
};

export default About;
